import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import i18n from '../i18n'
import router from '../router'
import App from '../App.vue'
import { bootstrapMasqueradeExchange } from '../lib/masqueradeBootstrap'
import '../styles/application.css'

async function boot() {
  await bootstrapMasqueradeExchange()

  const app = createApp(App)
  const head = createHead()

  const { glitchtipDsn, release, environment } = globalThis.__APP_CONFIG__ || {}
  if (glitchtipDsn) {
    const Sentry = await import('@sentry/vue')
    Sentry.init({
      app,
      dsn: glitchtipDsn,
      release,
      environment,
      autoSessionTracking: false,
      tracesSampleRate: 0.5,
      integrations: [Sentry.browserTracingIntegration({ router })],
    })
  }

  app.use(createPinia())
  app.use(i18n)
  app.use(head)
  app.use(router)
  app.mount('#app')
}

boot()
